module.exports = __webpack_public_path__ + "img/cookiebot.2949e26f.jpg";